import type { RootState } from '@/rootReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import Loader, { Status } from '@/components/Loader/Loader';

import './styles.scss';
import {
	EmailSecondary,
	GoogleButtonIcon,
	MsButtonIcon
} from '@/assets/images';

import {
	startNylasUser,
	startNylasUserCalendar
} from '../emailOnboardingActions';

export default function EmailOnboarding(): JSX.Element {
	const [user] = useSelector((state: RootState) => [
		state.user.getIn(['authorize', 'user']).toJS()
	]);

	const dispatch = useDispatch();

	const { pathname } = useLocation();

	const startEmailSignup = payload => dispatch(startNylasUser(payload));

	const startEmailCalendarSignup = payload =>
		dispatch(startNylasUserCalendar(payload));

	const helpSignupLink = (() => {
		return 'https://meetings.hubspot.com/idris-battou';
	})();

	return (
		<div className="email-onboarding-holder">
			{!user ? (
				<div className="user-loader">
					<Loader status={Status.LOADING} />
				</div>
			) : (
				<>
					{/* If the user is using re2SharedDomains and attempts to access a verify email page, they're redirected */}
					{user?.re2SharedDomain &&
						(pathname === '/verify-email-onboarding' ||
							pathname === '/email-onboarding' ||
							pathname === '/email-calendar-onboarding') && (
							<>{window.location.replace('/')}</>
						)}
					{user && pathname === '/verify-email-onboarding' && (
						<>
							<div className="email-onboarding-button-holder">
								<div className="email-onboarding-title">
									Verify your email to get started
								</div>
								<div
									className="signup-button"
									onClick={() => {
										startEmailSignup({ user });
									}}
									onKeyDown={() => {
										startEmailSignup({ user });
									}}
								>
									<GoogleButtonIcon className="email-logo email-logo-a" />
									<MsButtonIcon className="email-logo email-logo-b" />
									<EmailSecondary className="email-logo email-logo-c" />
									<span className="button-text">
										Verify Your Email
									</span>
								</div>
							</div>
							<div className="documentation-link">
								Having trouble? Check out how to fix these
								<a
									href="https://learn.re2.ai/faq-and-advanced-features#nylas-email-onboarding"
									target="_blank"
									rel="noreferrer"
								>
									<span className="link-text">
										&nbsp;common errors
									</span>
								</a>
							</div>
							<div className="bottom-banner">
								<div className="bottom-banner-title">
									Need more assistance?
								</div>
								<div className="bottom-banner-blurb">
									Schedule time with one of our technical
									experts to walk through it one-on-one
								</div>
								<a
									href={helpSignupLink}
									target="_blank"
									rel="noreferrer"
								>
									<div className="bottom-banner-button">
										Schedule help
									</div>
								</a>
							</div>
						</>
					)}
					{user && pathname === '/email-onboarding' && (
						<>
							<div className="email-onboarding-button-holder">
								<div className="email-onboarding-title">
									Verify your email to get started
								</div>
								<div
									className="signup-button"
									onClick={() => {
										startEmailSignup({ user });
									}}
									onKeyDown={() => {
										startEmailSignup({ user });
									}}
								>
									<GoogleButtonIcon className="email-logo email-logo-a" />
									<MsButtonIcon className="email-logo email-logo-b" />
									<EmailSecondary className="email-logo email-logo-c" />
									<span className="button-text">
										Verify Your Email
									</span>
								</div>
							</div>
							<div className="documentation-link">
								Having trouble? Check out how to fix these
								<a
									href="https://learn.re2.ai/faq-and-advanced-features#nylas-email-onboarding"
									target="_blank"
									rel="noreferrer"
								>
									<span className="link-text">
										&nbsp;common errors
									</span>
								</a>
							</div>
							<div className="bottom-banner">
								<div className="bottom-banner-title">
									Need more assistance?
								</div>
								<div className="bottom-banner-blurb">
									Schedule time with one of our technical
									experts to walk through it one-on-one
								</div>
								<a
									href={helpSignupLink}
									target="_blank"
									rel="noreferrer"
								>
									<div className="bottom-banner-button">
										Schedule help
									</div>
								</a>
							</div>
						</>
					)}

					{user && pathname === '/email-calendar-onboarding' && (
						<>
							<div className="email-onboarding-button-holder">
								<div className="email-onboarding-title">
									Verify your email to get started
								</div>
								<div
									className="signup-button signup-button-calendar"
									onClick={() => {
										startEmailCalendarSignup({ user });
									}}
									onKeyDown={() => {
										startEmailCalendarSignup({ user });
									}}
								>
									<GoogleButtonIcon className="email-logo email-logo-a" />
									<MsButtonIcon className="email-logo email-logo-b" />
									<EmailSecondary className="email-logo email-logo-c" />
									<span className="button-text">
										Verify Your Email/Calendar
									</span>
								</div>
							</div>
							<div className="documentation-link">
								Having trouble? Check out how to fix these
								<a
									href="https://learn.re2.ai/faq-and-advanced-features#nylas-email-onboarding"
									target="_blank"
									rel="noreferrer"
								>
									<span className="link-text">
										&nbsp;common errors
									</span>
								</a>
							</div>
							<div className="bottom-banner">
								<div className="bottom-banner-title">
									Need more assistance?
								</div>
								<div className="bottom-banner-blurb">
									Schedule time with one of our technical
									experts to walk through it one-on-one
								</div>
								<a
									href={helpSignupLink}
									target="_blank"
									rel="noreferrer"
								>
									<div className="bottom-banner-button">
										Schedule help
									</div>
								</a>
							</div>
						</>
					)}
				</>
			)}
		</div>
	);
}
